// Official Indian OEM websites + dealer locator deep-links.
// Used from CarDetail's bottom CTA so users can pivot to the brand's own site
// or find the nearest showroom instead of (or in addition to) submitting a lead.

export const OEM_LINKS = {
  "maruti-suzuki": {
    site: "https://www.marutisuzuki.com",
    dealer: "https://www.marutisuzuki.com/channels/arena/find-a-dealer",
    label: "Maruti Suzuki",
  },
  tata: {
    site: "https://cars.tatamotors.com",
    dealer: "https://cars.tatamotors.com/dealer-locator.html",
    label: "Tata Motors",
  },
  mahindra: {
    site: "https://auto.mahindra.com",
    dealer: "https://auto.mahindra.com/find-a-dealer",
    label: "Mahindra",
  },
  hyundai: {
    site: "https://www.hyundai.com/in/en",
    dealer: "https://www.hyundai.com/in/en/find-a-dealer",
    label: "Hyundai India",
  },
  kia: {
    site: "https://www.kia.com/in",
    dealer: "https://www.kia.com/in/find-a-dealer.html",
    label: "Kia India",
  },
  toyota: {
    site: "https://www.toyotabharat.com",
    dealer: "https://www.toyotabharat.com/toyota-dealers",
    label: "Toyota India",
  },
  honda: {
    site: "https://www.hondacarindia.com",
    dealer: "https://www.hondacarindia.com/dealer-locator",
    label: "Honda Cars India",
  },
  mg: {
    site: "https://www.mgmotor.co.in",
    dealer: "https://www.mgmotor.co.in/dealer-locator",
    label: "MG Motor India",
  },
  skoda: {
    site: "https://www.skoda-auto.co.in",
    dealer: "https://www.skoda-auto.co.in/find-dealer",
    label: "Škoda India",
  },
  volkswagen: {
    site: "https://www.volkswagen.co.in",
    dealer: "https://www.volkswagen.co.in/en/dealer-search.html",
    label: "Volkswagen India",
  },
  byd: {
    site: "https://www.byd.com/in",
    dealer: "https://www.byd.com/in/showroom-locator",
    label: "BYD India",
  },
  bmw: {
    site: "https://www.bmw.in",
    dealer: "https://www.bmw.in/en/topics/discover/dealer-locator.html",
    label: "BMW India",
  },
  "mercedes-benz": {
    site: "https://www.mercedes-benz.co.in",
    dealer: "https://www.mercedes-benz.co.in/passengercars/being-an-owner/dealer-locator.html",
    label: "Mercedes-Benz India",
  },
  audi: {
    site: "https://www.audi.in",
    dealer: "https://www.audi.in/in/web/en/dealer-locator.html",
    label: "Audi India",
  },
  volvo: {
    site: "https://www.volvocars.com/in",
    dealer: "https://www.volvocars.com/in/dealers/",
    label: "Volvo India",
  },
  citroen: {
    site: "https://www.citroen.in",
    dealer: "https://www.citroen.in/en/find-a-dealer.html",
    label: "Citroën India",
  },
  renault: {
    site: "https://www.renault.co.in",
    dealer: "https://www.renault.co.in/dealer-locator.html",
    label: "Renault India",
  },
  nissan: {
    site: "https://www.nissan.in",
    dealer: "https://www.nissan.in/dealer-locator.html",
    label: "Nissan India",
  },
  jeep: {
    site: "https://www.jeep-india.com",
    dealer: "https://www.jeep-india.com/dealer-locator.html",
    label: "Jeep India",
  },
};

export function oemFor(brandSlug) {
  return OEM_LINKS[brandSlug] || null;
}
